import { SelectOption } from 'govwell-ui/components/Select/types'
import { CompanyFragment } from 'types/graphql'

import CompanySearch from 'src/components/Selects/CompanySearch'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: string
  field: TanstackField<CompanyFragment | undefined, TKey>
  getIsOptionDisabled?: (option: SelectOption<CompanyFragment>) => boolean
  isRequired?: boolean
  label?: string
  placeholder?: string
}

const CompanySelectField = <TKey extends string>({
  caption,
  field,
  getIsOptionDisabled,
  isRequired,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  return (
    <CompanySearch
      caption={caption}
      errorMessage={errorMessage}
      getIsOptionDisabled={getIsOptionDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default CompanySelectField
